import type { BoxProps } from '@mui/material';
import { Box, styled, Typography } from '@mui/material';
import type { FC } from 'react';
import EmptyStateSvg from 'assets/EmptyState.svg?react';

const StyledSvgImage = styled(EmptyStateSvg)`
  height: 90px;
  margin: 0 auto;
  display: block;
`;

interface EmptyStateComponentProps extends Omit<BoxProps, 'title'> {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
}

const EmptyStateComponent: FC<EmptyStateComponentProps> = ({ title, subtitle, ...props }) => (
  <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }} {...props}>
    <Box sx={{ width: 320 }}>
      <StyledSvgImage />
      <Typography variant="h6" sx={{ mt: 3, textAlign: 'center' }}>
        {title}
      </Typography>
      <Typography variant="body1" sx={{ mt: 1, opacity: 0.6, textAlign: 'center' }}>
        {subtitle}
      </Typography>
    </Box>
  </Box>
);

export default EmptyStateComponent;
